import { useQuery } from 'react-query';

import { toast } from '@savgroup-front-common/core/atoms/Toast';
import { FileSummary } from '@savgroup-front-common/types';
import { SellerService } from '@/api';

interface UseGetVatValueBySellerCountryArgs {
  fileSummary: FileSummary;
}

const useGetVatValueBySellerCountry = ({
  fileSummary,
}: UseGetVatValueBySellerCountryArgs) => {
  const ownerId = fileSummary.ownerId;
  const sellerId = fileSummary.sellerId;

  const { data, isLoading } = useQuery(
    ['useGetVatValueBySellerCountry', { sellerId, ownerId }],
    async () => {
      if (!sellerId || !ownerId) {
        return undefined;
      }

      const response = await SellerService.getVatRateBySellerIdQuery({
        ownerId,
        sellerId,
      });

      if (response.failure) {
        toast.error(response.errors[0].message);

        return undefined;
      }

      return response.value;
    },
  );

  return {
    vatRate: data || 0.2, // Default VAT rate for France (20%)
    isLoading,
  };
};

export default useGetVatValueBySellerCountry;
